exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.priority[data-v-847dbb5e]{display:inline-block;width:8px;height:8px;background-color:transparent;border-radius:50%;margin-right:5px}span.priority.urgent[data-v-847dbb5e]{background-color:#a82323}span.priority.high[data-v-847dbb5e]{background-color:#de5143}span.priority.medium[data-v-847dbb5e]{background-color:#ffe066}span.priority.low[data-v-847dbb5e]{background-color:#3e7c00}.cursor-pointer[data-v-847dbb5e]{cursor:pointer}.warning-message[data-v-847dbb5e]{background:#f4e6e6;border:1px solid #c95c5c;color:#740606;padding:18px 15px;border-radius:3px;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-847dbb5e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/ResidentPortalInformation.vue
// module id = fng7
// module chunks = 0 1